module.exports = __webpack_public_path__ + "media/images/belgium-flag-round-b70c685a86c112235d2425e859ca2b33.png";